export const PLAN_ROUTE_MAP = {
    'multichannel': 'converse-desk',
    'conversation': 'converse-desk',
    'automation': 'v2/campaign'
}

export const DEFAULT_ROUTE = 'converse-desk'
export const ZOHO_DEFAULT_ROUTE = 'getting-started'
export const SCREEN_MAGIC_EMAIL = "@screen-magic.com"
export const CAPTCHA_DISABLED_ENVS = ["dev", "staging", "qa"]
export const MAX_RESEND_EMAIL = 3
export const RESEND_EMAIL_INTERVAL = 60
export const WORKSPACE_REDIRECT_TIMEOUT = 8

export const ABORT_API="/api/v2/sf_abort_installation"

export const CANCEL_PAGE_TIMEOUT=8
export const SF_INSTALL_API="/api/v2/sf_installation_configuration"
export const SF_PACKAGE_INFO_API="/api/v1/trial/sf/account/package_info"